import { render, staticRenderFns } from "./DocEditorPreview.vue?vue&type=template&id=a6abba66&scoped=true&"
import script from "./DocEditorPreview.vue?vue&type=script&lang=js&"
export * from "./DocEditorPreview.vue?vue&type=script&lang=js&"
import style0 from "./DocEditorPreview.vue?vue&type=style&index=0&id=a6abba66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6abba66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ui-spec-md/ui-spec-md/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('a6abba66', component.options)
    } else {
      api.reload('a6abba66', component.options)
    }
    module.hot.accept("./DocEditorPreview.vue?vue&type=template&id=a6abba66&scoped=true&", function () {
      api.rerender('a6abba66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UISpec/DocEditor/DocEditorPreview.vue"
export default component.exports